import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { signInFx, useAuthProvider, useErrorMessage } from '@/store';
import { useAuth } from '../AuthProvider/AuthProvider';
import { SignInRoute } from '@/models';

const STYLES = { display: 'flex', justifyContent: 'center', marginTop: '130px' };
const BASE_URL = window.location.origin;

export const OktaAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { fallback } = useAuth();
  const errorMessage = useErrorMessage();
  const authProvider = useAuthProvider();

  const oktaTokens = useMemo(() => {
    const locationHash = queryString.parse(location.hash);

    return { oktaIdToken: locationHash.id_token, oktaAccessToken: locationHash.access_token };
  }, [location]);

  useEffect(() => {
    if (authProvider && oktaTokens.oktaAccessToken && oktaTokens.oktaIdToken) {
      const signInHandler = async () => {
        const result = await signInFx({ body: JSON.stringify(oktaTokens), authType: 'okta' });

        history.replaceState(null, '', `${BASE_URL}/${SignInRoute.AccessDenied}`);
        result && navigate(authProvider.loginRedirectUri);
      };

      void signInHandler();
    }
  }, [navigate, oktaTokens, authProvider]);

  return <div style={STYLES}>{errorMessage ?? fallback}</div>;
};
